import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_ANALYTICS_REPORT_DROPDOWN_SUCCESS action and sets an array of analytics reports in the store
 * @param {Array} [state] The analytics reports currently in the store, or the initial state
 * @param {Object} action The action to be handled
 * @returns {Array} The analytics reports
 */
export default function analyticsReportDropdown(
  state = initialState.analyticsReports,
  action
) {
  switch (action.type) {
    case actions.LOAD_ANALYTICS_REPORT_DROPDOWN_SUCCESS:
      return action.analyticsReports;
    case actions.UNLOAD_CLIENT:
      return initialState.analyticsReports;
    default:
      return state;
  }
}
